import React from "react";
import { Link } from "react-router-dom";

export default () => (
  <div
    className="signin animated fadeIn mar-b-100 mar-t-100"
    style={{ color: "black" }}
  >
    <div className="box-outer">
      <div className="box-inner">
        <h1>Email Sent</h1>
        <div>
          <p>
            An email has been sent to the email address you provided. Please add
            noreply@cardcash.com to your address book to ensure our messages
            don't go to spam.
          </p>
          <span>Are you still having trouble recovering your password?</span>
          <br />
          <Link to="contact">
            <span className="lnk">Contact Us</span>
          </Link>
        </div>
      </div>
    </div>
  </div>
);
